import { Injectable } from "@nestjs/common";
import { InjectDataSource, InjectRepository } from "@nestjs/typeorm";
import { DataSource, Repository } from "typeorm";
import { PurchaseOrderEntity } from "./entities/purchase-order-entity";
import { CommonResponseModel,CustomerOrderStatusEnum,GrnItemsFormDto, ItemTypeEnum, LifeCycleStatusEnum, MaterailViewDto, MaterialTypeDto, PerforationEnum, PoReq, PurchaseStatusEnum, PurchaseViewDto, StatusEnum, VendorIdReq, xlNoReq } from "@project-management-system/shared-models";
import { PurchaseOrderDto } from "./dto/purchase-order-dto";
import { PurchaseOrderFbricEntity } from "./entities/purchase-order-fabric-entity";
import { PurchaseOrderTrimEntity } from "./entities/purchase-order-trim-entity";
import { FORMERR } from "dns";
import { purchaseOrdeIdreq } from "./dto/purchase-order-id-req";
import { FabriCWeaveDto } from "../fabric weave/dto/fabric-weave.dto";
import { PurchaseOrderRepository } from "./repo/purchase-order-repository";
import { PurchaseOrderFabricRepository } from "./repo/purchase-order-fabric-repository";
import { PurchaseOrderTrimRepository } from "./repo/purchase-order-trim-repository";
import { PurchaseOrderItemsEntity } from "./entities/purchase-order-items-entity";
import { SampleRequestRepository } from "../sample-dev-request/repo/sample-dev-req-repo";
import { IndentRepository } from "../indent/dto/indent-repository";
import { GrnRepository } from "../grn/dto/grn-repository";
let moment = require('moment');
import * as nodemailer from 'nodemailer';
import { request } from "http";
import { BuyersService } from '../buyers/buyers.service';
import { Cron } from '@nestjs/schedule';

@Injectable()
export class PurchaseOrderService {
          private transporter: nodemailer.Transporter;
    
    constructor(
        // @InjectRepository(PurchaseOrderEntity)
        private poRepo: PurchaseOrderRepository,
        private grnRepo: GrnRepository,
        private indentRepo:IndentRepository,
        private poFabricRepo: PurchaseOrderFabricRepository,
        private poTrimRepo: PurchaseOrderTrimRepository,
        @InjectDataSource()
        private dataSource: DataSource,
        private sampleReqRepo:SampleRequestRepository,
        private buyerService:BuyersService,
        @InjectRepository(PurchaseOrderItemsEntity)
        private poItemRepo: Repository<PurchaseOrderItemsEntity>,
    ) { 
        this.transporter = nodemailer.createTransport({
                                service: 'gmail',
                                auth: {
                                    user: 'helpdesk@schemaxtech.com',
                                    pass: 'jend gpnz htps asjn',
                                },
                            });
    }



    async cretePurchaseOrder(req: PurchaseOrderDto): Promise<CommonResponseModel> {
        // console.log(req);
        try {

            const today = new Date();
            const CurrentYear = today.getFullYear();
            const CurrentMonth = today.getMonth();
            let fromDate = 0;
            let toDate = 0;
            let itemType;
            let poItemType

            if(req.poMaterialType === "Fabric"){
                itemType = 'F';
                poItemType = req.poMaterialType
            }
            else{
                itemType = 'T';
                poItemType = 'Trim'
            }
            const data = 'select  max(ref_no) as poId from purchase_order where po_material_type = "'+poItemType+'"';
                let totalPO = await this.poRepo.query(data)
            // if (!isUpdate) {
                if (CurrentMonth < 4) {
                    fromDate = (CurrentYear-1);
                    toDate = (CurrentYear);
                } else {
                    fromDate = (CurrentYear);
                    toDate = (CurrentYear + 1);
                }

            // }
            
            let val = totalPO[0].poId + 1;


            let refNo = val + "";
            while (refNo.length < 4) refNo = "0" + refNo;

            let poNumber = "PO/" + (fromDate.toString().substr(-2)) + "-" + (toDate.toString().substr(-2)) + "/" + itemType + "/" + refNo;

            // console.log(poNumber);
            // const currentYear = moment().format('YYYY')
            // const currentDate = moment();
            // const netyaer = currentDate.year();
            // const nextYear = netyaer + 1;
            // let FromYear = currentYear.toString().substr(-2)
            // let ToYear = (nextYear).toString().substr(-2)
            // console.log(ToYear)
            // console.log('$$$$')
            // if buyer wise ponumber generation happens need to include Buyer also.
            // const data = 'select max(purchase_order_id) as poId from purchase_order where po_material_type = "'+req.poMaterialType+'"';
            // const maxId = await this.poRepo.query(data)
            // let val = maxId[0].poId + 1;
            // if (maxId[0].poId == null) {
            //     poNumber = 'PO/' + FromYear + '-' + ToYear + '/' + '000001' + ''
            // } else {
            //     poNumber = 'PO/' + FromYear + '-' + ToYear + '/' + val.toString().padStart(5, 0) + ''
            // }
            let poItemInfo = []
            const poEntity = new PurchaseOrderEntity()
            poEntity.poNumber = poNumber
            poEntity.vendorId = req.vendorId
            // poEntity.styleId = req.styleId
            poEntity.buyerId = req.buyerId
            poEntity.plantId = req.plantId
            poEntity.expectedDeliveryDate = req.expectedDeliveryDate
            poEntity.purchaseOrderDate = req.purchaseOrderDate
            poEntity.yourRefNo = req.yourRefNo
            poEntity.createdUser = req.marketingMail
            poEntity.createdUser = req.marketingMail
            poEntity.pIDate=req.pIDate
            poEntity.gstNumber=req.gstNumber
            if(req.poMaterialType === "Fabric"){
                poItemType = req.poMaterialType;
            }else{
                poItemType = 'Trim';
            }
            poEntity.poMaterialType = poItemType
            poEntity.poAgainst = req.poAgainst
            poEntity.currencyId=req.currencyId
            poEntity.exchangeRate=req.exchangeRate
            poEntity.deliveryAddress=req.deliveryAddress
            poEntity.totalAmount=req.totalAmount
            poEntity.deliveryMethods=req.deliveryMethods
            poEntity.deliveryTerms=req.deliveryTerms
            poEntity.paymentMethods=req.paymentMethods
            poEntity.paymentTerms=req.paymentTerms
            poEntity.packingTerms=req.packingTerms
            poEntity.freightTerms=req.freightTerms
            poEntity.refNo=Number(refNo)
            poEntity.poTypeId=req.poTypeId
            poEntity.addressId=req.addressId
            for(const item of req.poItemInfo){
                // console.log(item,'$$$$')
                const pofabricEntity = new PurchaseOrderItemsEntity()
                        pofabricEntity.colourId = item.colourId
                        pofabricEntity.m3ItemId = item.m3ItemId
                        pofabricEntity.poQuantity = item.poQuantity
                        pofabricEntity.grnQuantity = item.grnQuantity
                        pofabricEntity.quantityUomId = item.quantityUomId
                        pofabricEntity.poQuantity = item.poQuantity
                        pofabricEntity.quantityUomId = item.quantityUomId
                        pofabricEntity.sampleItemId = item.sampleItemId
                        pofabricEntity.indentItemId = item.indentItemId
                        pofabricEntity.unitPrice = item.unitPrice
                        pofabricEntity.discount = item.discount
                        pofabricEntity.transportation = item.transportation
                        pofabricEntity.tax = item.tax
                        pofabricEntity.subjectiveAmount = item.subjectiveAmount
                        pofabricEntity.styleId = item.styleId
                        pofabricEntity.sizeId = item.sizeId
                        pofabricEntity.hsnCode = item.hsnCode
                        pofabricEntity.itemDescription = item.itemDescription
                        pofabricEntity.purchaseUomId = item.purchaseUomId
                        pofabricEntity.conversionFactor = item.conversionFactor
                        pofabricEntity.inHouseDate=item.inHouseDate
                        pofabricEntity.shadeNo = item.shadeNo
                        pofabricEntity.convertedQuantity=item.convertedQuantity
                        pofabricEntity.plantId=req.plantId
                        pofabricEntity.unitPriceQty=item.unitPriceQty

                        if((req.poAgainst).toUpperCase() == 'SAMPLE ORDER'){
                            pofabricEntity.materialType = ItemTypeEnum[(req.poMaterialType).toUpperCase()]
                        }
                        if((req.poAgainst).toUpperCase() == 'INDENT'){
                            pofabricEntity.materialType = ItemTypeEnum[(item.materialType).toUpperCase()]
                        }
                        poItemInfo.push(pofabricEntity)
            }
            poEntity.poItemInfo=poItemInfo
            // console.log(poEntity,'poentity'  )
            // let save
            const save = await this.poRepo.save(poEntity)
            
            if (save) {
                if((req.poAgainst).toUpperCase() == 'INDENT'){
                    const indentUpdate = await this.indentRepo.update({indentId:req.poItemInfo[0].indentId},{status:CustomerOrderStatusEnum.IN_PROGRESS})
                    for(const update of req.poItemInfo){
                        if(update.indentId != undefined){

                        }
                    }
                }
                if((req.poAgainst).toUpperCase() == 'SAMPLE ORDER'){
                    for(const update of req.poItemInfo){
                        if(update.sampleReqId != undefined){
                           const  dat = await this.sampleReqRepo.update({SampleRequestId:update.sampleReqId},{lifeCycleStatus:LifeCycleStatusEnum.PO_RAISED})
                        }
                    }
                }
               
                 
                  

              try{
                return new CommonResponseModel(true, 1, 'purchased Order Created Sucessfully',save)
              }catch(error){

                  return new CommonResponseModel(false, 0, 'Something went Wrong')
              }
            }
        } catch (err) {
            throw err
        }
    }

    // async updatePurchaseOrder(req: any): Promise<CommonResponseModel> {
    // // console.log(req,'req');
    
    //     try{
    //     const result = await this.poItemRepo.update({ purchaseOrderItemId: req.purchaseOrderItemId },
    //         {unitPrice:req.unitPrice,poQuantity:req.poQty})
    //     if(result.affected>0){
    //         return new CommonResponseModel(true, 1, 'purchased Order updated Sucessfully',result)
    //     }
    //     }catch(err){
    //         console.log(err);
            
    //     }
    // }
    async updatePurchaseOrder(req: PurchaseOrderDto): Promise<CommonResponseModel> {
        try {
          
            const today = new Date();
         
            let poItemType
            const exist  = await this.poRepo.findOne({where:{purchaseOrderId:req.purchaseOrderId}})
            // if(req.poMaterialType === "Fabric"){
            //     itemType = 'F';
            //     poItemType = req.poMaterialType
            // }
            // else{
            //     itemType = 'T';
            //     poItemType = 'Trim'
            // }
            // const data = 'select  max(ref_no) as poId from purchase_order where po_material_type = "'+poItemType+'"';
            //     let totalPO = await this.poRepo.query(data)
            // // if (!isUpdate) {
            //     if (CurrentMonth < 4) {
            //         fromDate = (CurrentYear-1);
            //         toDate = (CurrentYear);
            //     } else {
            //         fromDate = (CurrentYear);
            //         toDate = (CurrentYear + 1);
            //     }

            // // }
            
            // let val = totalPO[0].poId + 1;


            // let refNo = val + "";
            // while (refNo.length < 4) refNo = "0" + refNo;

            // let poNumber = "PO/" + (fromDate.toString().substr(-2)) + "-" + (toDate.toString().substr(-2)) + "/" + itemType + "/" + refNo;

            // console.log(poNumber);
            // const currentYear = moment().format('YYYY')
            // const currentDate = moment();
            // const netyaer = currentDate.year();
            // const nextYear = netyaer + 1;
            // let FromYear = currentYear.toString().substr(-2)
            // let ToYear = (nextYear).toString().substr(-2)
            // console.log(ToYear)
            // console.log('$$$$')
            // if buyer wise ponumber generation happens need to include Buyer also.
            // const data = 'select max(purchase_order_id) as poId from purchase_order where po_material_type = "'+req.poMaterialType+'"';
            // const maxId = await this.poRepo.query(data)
            // let val = maxId[0].poId + 1;
            // if (maxId[0].poId == null) {
            //     poNumber = 'PO/' + FromYear + '-' + ToYear + '/' + '000001' + ''
            // } else {
            //     poNumber = 'PO/' + FromYear + '-' + ToYear + '/' + val.toString().padStart(5, 0) + ''
            // }
            let poItemInfo = []
            const poEntity = new PurchaseOrderEntity()
            poEntity.purchaseOrderId = req.purchaseOrderId
            poEntity.poNumber = req.poNumber
            poEntity.vendorId = req.vendorId
            // poEntity.styleId = req.styleId
            poEntity.buyerId = req.buyerId
            poEntity.plantId = req.plantId
            poEntity.expectedDeliveryDate = req.expectedDeliveryDate
            poEntity.purchaseOrderDate = req.purchaseOrderDate
            poEntity.yourRefNo = req.yourRefNo
            // if(!isUpdate){
            // poEntity.createdUser = req.marketingMail
            // poEntity.createdUser = req.marketingMail
            // }
            // if(isUpdate){
            poEntity.updatedUser = req.marketingMail
            poEntity.updatedAt = req.updatedAt
            // poEntity.purchaseOrderId = req.purchaseOrderId
            // }
            poEntity.pIDate=req.pIDate
            poEntity.gstNumber=req.gstNumber
            if(req.poMaterialType === "Fabric"){
                poItemType = req.poMaterialType;
            }else{
                poItemType = 'Trim';
            }
            poEntity.poMaterialType = poItemType
            poEntity.poAgainst = req.poAgainst
            poEntity.currencyId=req.currencyId
            poEntity.exchangeRate=req.exchangeRate
            poEntity.deliveryAddress=req.deliveryAddress
            poEntity.totalAmount=req.totalAmount
            poEntity.deliveryMethods=req.deliveryMethods
            poEntity.deliveryTerms=req.deliveryTerms
            poEntity.paymentMethods=req.paymentMethods
            poEntity.paymentTerms=req.paymentTerms
            poEntity.packingTerms=req.packingTerms
            poEntity.freightTerms=req.freightTerms
            // poEntity.refNo=Number(refNo)
            poEntity.poTypeId=req.poTypeId
            poEntity.addressId=req.addressId
            for(const item of req.poItemInfo){
                // console.log(item,'$$$$')
                const pofabricEntity = new PurchaseOrderItemsEntity()
                pofabricEntity.purchaseOrderEntity = new PurchaseOrderEntity()
                pofabricEntity.purchaseOrderEntity.purchaseOrderId = req.purchaseOrderId
                        pofabricEntity.colourId = item.colourId
                        pofabricEntity.m3ItemId = item.m3ItemId
                        pofabricEntity.poQuantity = item.poQuantity
                        pofabricEntity.grnQuantity = item.grnQuantity
                        pofabricEntity.quantityUomId = item.quantityUomId
                        pofabricEntity.poQuantity = item.poQuantity
                        pofabricEntity.quantityUomId = item.quantityUomId
                        pofabricEntity.sampleItemId = item.sampleItemId
                        pofabricEntity.indentItemId = item.indentItemId
                        pofabricEntity.unitPrice = item.unitPrice
                        pofabricEntity.discount = item.discount
                        pofabricEntity.transportation = item.transportation
                        pofabricEntity.tax = item.tax
                        pofabricEntity.subjectiveAmount = item.subjectiveAmount
                        pofabricEntity.styleId = item.styleId
                        pofabricEntity.sizeId = item.sizeId
                        pofabricEntity.hsnCode = item.hsnCode
                        pofabricEntity.itemDescription = item.itemDescription
                        pofabricEntity.purchaseUomId = item.purchaseUomId
                        pofabricEntity.conversionFactor = item.conversionFactor
                        pofabricEntity.inHouseDate=item.inHouseDate
                        pofabricEntity.shadeNo = item.shadeNo
                        pofabricEntity.convertedQuantity=item.convertedQuantity
                        pofabricEntity.plantId=req.plantId
                        pofabricEntity.unitPriceQty=item.unitPriceQty

                        if((req.poAgainst)?.toUpperCase() == 'SAMPLE ORDER'){
                            pofabricEntity.materialType = ItemTypeEnum[(req.poMaterialType)?.toUpperCase()]
                        }
                        if((req.poAgainst)?.toUpperCase() == 'INDENT'){
                            pofabricEntity.materialType = ItemTypeEnum[(item.materialType)?.toUpperCase()]
                        }
                        poItemInfo.push(pofabricEntity)
            }
            poEntity.poItemInfo=poItemInfo
            // console.log(poEntity,'poentity'  )
            // let save

            if(exist){
                console.log('update poEntity',poEntity);
                
                // true aindpudu avali purchase id tho find create at tappa ani update cheyyali 
                const update = await this.poRepo.save(poEntity)
                if(update){
                    return new CommonResponseModel(true, 1, 'purchased Order updated Sucessfully',update)
                }else{
                    return new CommonResponseModel(false, 0, 'Something went Wrong in updating')
                }
            }
        } catch (err) {
            throw err
        }
    }
    async getAllPONumbers(req: VendorIdReq): Promise<CommonResponseModel> {
        try {
            let buyerId
            if(req.buyerRefNo != "admin" && req.buyerRefNo != null && req.buyerRefNo != 'null' && req.buyerRefNo!= ""){
                const buyerdata = `select buyer_id from buyers where external_ref_number = '${req.buyerRefNo}'`;
                const res = await this.dataSource.query(buyerdata)
                buyerId = res[0].buyer_id
            }
            let query = `
            SELECT po.purchase_order_id AS purchaseOrderId,po.po_number AS poNumber,po.vendor_id AS vendorId,po.po_material_type AS materialType,po.po_against AS poAgainst,
            mt.trim_mapping_id AS trimMappingId
            FROM purchase_order po
            LEFT JOIN purchae_order_items poi ON poi.purchase_order_id = po.purchase_order_id
            LEFT JOIN m3_trims mt ON mt.m3_trim_Id=poi.m3_item_id
            WHERE status NOT IN ('cancelled', 'closed')`
            if(req.buyerRefNo != "admin" && req.buyerRefNo != null && req.buyerRefNo != 'null' && req.buyerRefNo!= ""){
                query = query + ` AND po.buyer_id = '${buyerId}'`;
            }
            if (req.vendorId) {
                query = query + ` AND po.vendor_id = '${req.vendorId}'`;
            }
            query = query +` GROUP BY po.po_number ORDER BY po.po_number`
            const data = await this.dataSource.query(query)
            if (data.length > 0) {
                return new CommonResponseModel(true, 0, "PO Numbers retrieved successfully", data)
            } else {
                return new CommonResponseModel(false, 1, "No data found", [])
            }
        } catch (err) {
            throw (err)
        }
    }

    async getPODataById(req: VendorIdReq): Promise<CommonResponseModel> {
        try {
            // ,if.ifabric_id AS indentFabricId
            // console.log(req)
            req.materialType = req.materialType.toLowerCase().includes('trim') ? 'Trim' : 'Fabric' 
            let query
            if (req.materialType === 'Fabric') {
                query = `SELECT 0 AS indentQty,m.item_code AS m3itemCode,poi.m3_item_id as m3ItemCodeId,poi.po_quantity AS poQuantity,poi.quantity_uom_id AS quantityUomId,u.uom,poi.purchase_order_item_id as poItemId,m.description,
                poi.purchase_order_id AS purchaseOrderId,m.fabric_type AS m3ItemTypeId,ft.fabric_type_name AS m3ItemType,
                poi.grn_quantity AS grnQuantity,poi.sample_item_id AS sampleItemId,poi.indent_item_id as indentItemId,b.buyer_id AS buyerId,CONCAT(b.buyer_code,'-',b.buyer_name) AS buyer,s.style_id,s.style,poi.unit_price as unitPrice,poi.discount,t.tax_percentage as tax,t.tax_id as taxId,poi.transportation,poi.subjective_amount as subjectiveAmount,poi.po_item_status as poItemStatus,poi.colour_id as colourId,c.colour as colour, poi.item_type AS itemType,m.order_type as orderType,m.tolerance,m.min_moq_quantity as minMoqQuantity,m.max_moq_quantity as maxMoqQuantity,poi.converted_quantity as convertedQuantity `;
                if(req.poAgainst == 'Indent'){
                    query = query + `,i.indent_id as indentId `
                }
                if(req.poAgainst == 'Sample Order'){
                    query = query +  `,sr.sample_request_id as sampleRequestId `
                }
                query = query + `
                FROM purchae_order_items poi
                LEFT JOIN uom u ON u.id = poi.quantity_uom_id
                LEFT JOIN taxes t on t.tax_id = poi.tax
                LEFT JOIN m3_items m ON m.m3_items_Id = poi.m3_item_id
                LEFT JOIN fabric_type ft ON ft.fabric_type_id = m.fabric_type
                LEFT JOIN colour c ON c.colour_id = poi.colour_id
                `
                if (req.poAgainst == 'Indent') {
                    query = query + ` 
                    LEFT JOIN indent_fabric inf ON inf.ifabric_id = poi.indent_item_id
                    LEFT JOIN indent i ON i.indent_id = inf.indent_id 
                    LEFT JOIN style s ON s.style_id = i.style 
                    LEFT JOIN buyers b ON b.buyer_id = i.buyer_id
                    WHERE poi.purchase_order_id = ${req.poId}`
                }
                if (req.poAgainst === 'Sample Order') {
                    query = query + ` 
                    LEFT JOIN sample_request_fabric_info srf ON srf.fabric_info_id  = poi.sample_item_id   
                    LEFT JOIN sample_request sr ON sr.sample_request_id  = srf.sample_request_id                  
                    LEFT JOIN buyers b ON b.buyer_id = sr.buyer_id 
                    LEFT JOIN style s ON s.style_id = sr.style_id
                    WHERE poi.purchase_order_id = ${req.poId}`
                }
            }
            else {
                query = `SELECT 0 AS indentQty,mt.trim_code as m3itemCode,
                mt.category_id AS categoryId,cg.category,
                mt.color_id AS colorId,cl.colour as color,
                mt.content_id AS contentId,ct.content,
                mt.finish_id AS finishId,f.finish,
                mt.hole_id AS holeId,h.hole,
                mt.logo, mt.part,
                mt.quality_id AS qualityId,q.quality_name AS qualityName,
                mt.structure_id AS structureId,st.structure,
                mt.thickness_id AS thicknessId,th.thickness,
                mt.type_id AS typeId,ty.type,
                mt.uom_id AS UOMId, uom.uom as UOM,
                mt.variety_id AS varietyId,v.variety,
                mt.trim_category_id AS trimCategoryId,tr.trim_category AS trimCategory,
                mt.trim_mapping_id AS trimMappingId,
                tpm.structure, tpm.category, tpm.content, tpm.type, tpm.finish, tpm.hole, tpm.quality, tpm.thickness, tpm.variety, tpm.uom, tpm.color, tpm.logo, tpm.part,
                poi.m3_item_id AS m3ItemCodeId,mt.trim_type as m3ItemType,poi.purchase_order_id AS purchaseOrderId, poi.po_quantity AS poQuantity,poi.purchase_order_item_id as poItemId,
                poi.quantity_uom_id AS quantityUomId,u.uom,poi.grn_quantity AS grnQuantity,poi.indent_item_id as indentItemId, poi.sample_item_id as sampleItemId,b.buyer_id AS buyerId,CONCAT(b.buyer_code,'-',b.buyer_name) AS buyer,s.style_id,s.style,poi.unit_price as unitPrice,poi.discount,t.tax_percentage as tax,t.tax_id as taxId,poi.transportation,poi.subjective_amount as subjectiveAmount,poi.po_item_status as poItemStatus,poi.colour_id as colourId,c.colour as colour, poi.item_type AS itemType, mt.order_type as orderType,mt.tolerance,mt.min_moq_quantity as minMoqQuantity,mt.max_moq_quantity as maxMoqQuantity,poi.converted_quantity as convertedQuantity`
                if(req.poAgainst == 'Indent'){
                    query = query + `,i.indent_id as indentId`
                }
                if(req.poAgainst == 'Sample Order'){
                    query = query +  `,sr.sample_request_id as sampleRequestId `
                }
                query = query + `
                FROM purchae_order_items poi
                LEFT JOIN taxes t on t.tax_id = poi.tax
                LEFT JOIN uom u ON u.id = poi.quantity_uom_id
                LEFT JOIN m3_trims mt ON mt.m3_trim_Id=poi.m3_item_id
                LEFT JOIN colour c ON c.colour_id = poi.colour_id
                LEFT JOIN category cg ON cg.category_id = mt.category_id
                LEFT JOIN content ct ON ct.content_id = mt.content_id
                LEFT JOIN finish f ON f.finish_id = mt.finish_id
                LEFT JOIN hole h ON h.hole_id = mt.hole_id
                LEFT JOIN qualitys q ON q.quality_id = mt.quality_id
                LEFT JOIN structure st ON st.structure_id = mt.structure_id
                LEFT JOIN thickness th ON th.thickness_id = mt.thickness_id
                LEFT JOIN type ty ON ty.type_id = mt.type_id
                LEFT JOIN variety v ON v.variety_id = mt.variety_id
                LEFT JOIN trim tr ON tr.trim_id = mt.trim_category_id
                LEFT JOIN trim_params_mapping tpm ON tpm.trim_mapping_id = mt.trim_mapping_id
                LEFT JOIN colour cl ON cl.colour_id = mt.color_id
                LEFT JOIN uom uom ON uom.id = mt.uom_id
                LEFT JOIN purchase_order po ON po.purchase_order_id = poi.purchase_order_id
                LEFT JOIN buyers b ON b.buyer_id = po.buyer_id
                LEFT JOIN style s ON s.style_id = poi.style_id
                `
                if (req.poAgainst == 'Indent') {
                    query = query + ` 
                    LEFT JOIN indent_trims it ON it.itrims_id = poi.indent_item_id
                    LEFT JOIN indent i ON i.indent_id = it.indent_id 
                    WHERE poi.purchase_order_id = ${req.poId}`
                }
                if (req.poAgainst == 'Sample Order') {
                    query = query + `
                     LEFT JOIN sample_request_trim_info srf ON srf.trim_info_id  = poi.sample_item_id   
                     LEFT JOIN sample_request sr ON sr.sample_request_id  = srf.sample_request_id
                     WHERE poi.purchase_order_id = ${req.poId}`
                }

            }
            const itemData = await this.poTrimRepo.query(query)
            // console.log(itemData)
            const modifiedRes = itemData.map(item => {
                const trueValues = Object.keys(item)
                .filter(key => ["structure", "category", "content", "type", "finish", "hole", "quality", "thickness", "variety", "uom", "color", "logo", "part"].includes(key) && item[key] === 1)
                .map(key => key.toUpperCase());

                const concatenatedValues = trueValues.join('/');
                const label = trueValues.length > 0 ? "BUYER/TRIM TYPE/TRIM CATEGORY/":""

                const trimParams = label + concatenatedValues
                return { ...item, trimParams };
            });
            // console.log(modifiedRes,'@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@')
           
            const grnItemsArr: GrnItemsFormDto[] = []
            for (const rec of modifiedRes) {
                const receivedQty = rec.poQuantity - rec.grnQuantity
                const grnItemsDto = new GrnItemsFormDto(rec.poItemId, rec.m3ItemCodeId, rec.m3itemCode, rec.m3ItemType, rec.m3ItemTypeId, rec.poItemStatus, rec.quantityUomId, rec.uom, rec.unitPrice, rec.discount, rec.tax, rec.transportation, rec.subjectiveAmount, rec.grnQuantity, rec.poQuantity, rec.colourId, rec.colour, rec.sampleItemId, rec.indentItemId,rec.buyerId,rec.buyer,rec?.sampleRequestId,rec?.indentId,receivedQty,receivedQty,rec.categoryId,rec.category,rec.colorId,rec.color,rec.contentId,rec.content,rec.finishId,rec.finish,rec.holeId,rec.hole,rec.logo,rec.part,rec.qualityId,rec.qualityName,rec.structureId,rec.structure,rec.thicknessId,rec.thickness,rec.typeId,rec.type,rec.UOMId,rec.UOM,rec.varietyId,rec.variety,rec.trimCategoryId,rec.trimCategory,rec.trimMappingId,rec.style_id,rec.trimParams,0,0,0,0,"",0,undefined,"",undefined,"",0,0,rec.itemType,rec.description,rec.orderType,rec.minMoqQuantity,rec.maxMoqQuantity,rec.tolerance,rec.convertedQuantity,rec.indentQty);
                grnItemsArr.push(grnItemsDto)
            }
            const poQuery = `select p.plant_id AS plantId,p.purchase_order_id as poId,p.po_material_type as poMaterialType,p.po_against as poAgainst,p.grn_quantity as grnQuantity from purchase_order p where p.purchase_order_id = ${req.poId}`
            const poData = await this.poTrimRepo.query(poQuery)
             poData[0].grnItems = grnItemsArr


            if (grnItemsArr.length > 0) {
                return new CommonResponseModel(true, 0, "PO Numbers retrieved successfully", poData)
            } else {
                return new CommonResponseModel(false, 1, "No data found", [])
            }
        } catch (err) {
            // console.log(err)
            throw (err)
        }
    }

    async getMaterialTpye(): Promise<CommonResponseModel> {
        try {
            let query = `SELECT purchase_order_id AS purchaseOrderId,po_material_type AS materialType FROM purchase_order `
            const data = await this.dataSource.query(query)

            if (data.length > 0) {
                return new CommonResponseModel(true, 0, "PO Numbers retrieved successfully", data)
            } else {
                return new CommonResponseModel(false, 1, "No data found", [])
            }
        } catch (err) {
            throw (err)
        }

    }

    async getAllPoData(req?: PurchaseViewDto): Promise<CommonResponseModel> {
        try {
            let query2 = `Select po.status as status  FROM purchase_order po LEFT JOIN vendors v ON v.vendor_id = po.vendor_id `
            const statuses = await this.dataSource.query(query2);
            const count = Object.keys(PurchaseStatusEnum).map((key) => {

                return {
                    [PurchaseStatusEnum[key]]: statuses.filter((rec => rec.status === PurchaseStatusEnum[key])).length
                }
            });
            let query = `SELECT po.purchase_order_id AS id, po.po_number AS poNumber, po.vendor_id AS vendorId, v.vendor_code AS vendorCode,
            v.vendor_name AS vendorName,po.expected_delivery_date AS deliveryDate, po.purchase_order_date AS orderDate,po.status,po.po_material_type AS materialType
            FROM purchase_order po
            LEFT JOIN vendors v ON v.vendor_id = po.vendor_id `
            if (req) {
                if (req?.id) {
                    query += `where po.purchase_order_id = ${req?.id}`
                }
                if (req?.confirmStartDate) {
                    query += `WHERE ${req?.confirmStartDate ? `Date(expected_delivery_date) BETWEEN '${req?.confirmStartDate}' AND '${req?.confirmEndDate}'` : '1=1'}`
                }
                if (req?.poconfirmStartDate) {
                    query += `WHERE ${req?.poconfirmStartDate ? `Date(purchase_order_date) BETWEEN '${req?.poconfirmStartDate}' AND '${req?.poconfirmEndDate}'` : '1=1'}`
                }
                if (req?.status) {

                    query += `Where po.status = "${req.status}"`
                }
            }
            const data: any = await this.dataSource.query(query);
            data.push(count)
            if (data.length > 0) {
                return new CommonResponseModel(true, 0, "PO Numbers retrieved successfully", data)
            } else {
                return new CommonResponseModel(false, 1, "No data found", [])
            }
        } catch (err) {
            throw (err)
        }
    }


    

    async GetPurchaseData(req?: PurchaseViewDto): Promise<CommonResponseModel> {
                try {
            let query = 'SELECT po.is_freezed AS isFreezed,IF(po.po_against = "Sample Order" ,IF(po.po_material_type = "Fabric",srf.request_no,srt.request_no), IF(po.po_material_type = "Fabric",fi.request_no,ti.request_no)) AS indentNo, poi.purchase_order_item_id, po.plant_id AS plantId,p.plant_name AS plantName,null as pofabricData,null as poTrimdata, po.pIDate, s.style AS styleName,po.purchase_order_id AS purchaseOrderId,po.po_number AS poNumber,po.po_against as poAgainst,po.vendor_id AS vendorId,po.style_id AS styleId,po.vendor_id AS vendorId, v.vendor_name AS vendorName,po.expected_delivery_date AS expectedDeliverydate,purchase_order_date AS purchaseOrderDate,po.status AS poStatus,po_material_type AS poMaterialtype,b.buyer_name as buyername,po.buyer_id as buyerId,po.po_type_id as poTypeId,pt.order_type as orderType,ia.address,ia.code FROM purchase_order  po LEFT JOIN style s ON s.style_id=po.style_id LEFT JOIN  vendors v ON v.vendor_id= po.vendor_id LEFT JOIN buyers b ON  b.buyer_id = po.buyer_id left join purchase_order_type pt on pt.po_type_id=po.po_type_id left join invoice_address ia on ia.id = po.address_id left join plants p on p.plant_id = po.plant_id LEFT JOIN purchae_order_items poi ON poi.purchase_order_id=po.purchase_order_id LEFT JOIN indent_fabric itf ON itf.ifabric_id =poi.indent_item_id and poi.item_type = "FABRIC" LEFT JOIN indent_trims itt ON itt.itrims_id =poi.indent_item_id and poi.item_type != "FABRIC" LEFT JOIN indent ti ON ti.indent_id=itt.indent_id LEFT JOIN indent fi ON fi.indent_id=itf.indent_id LEFT join sample_request_fabric_info spf on spf.fabric_info_id = poi.sample_item_id and po.po_material_type = "Fabric" LEFT join sample_request_trim_info spt on spt.trim_info_id = poi.sample_item_id and po.po_material_type = "Trim" left join sample_request srf on srf.sample_request_id = spf.sample_request_id left join sample_request srt on srt.sample_request_id = spt.sample_request_id WHERE 1=1'

            let param :any={}
            if(req){
            //   if (req.id!== undefined){
            //     query += ` where po.purchase_order_id = ${req?.id}`
            //   }
              if (req.ExternalRefNo != "admin" && req.ExternalRefNo!=null && req.ExternalRefNo != ''){
                query += ` AND b.external_ref_number = '${req.ExternalRefNo}'`
              }
              if (req.status && req.status.length > 0) {
                // Assuming req.status is an array of enums
                const statusValues = req.status.map(status => `'${status}'`).join(',');
                query += ` AND po.status IN (${statusValues})`;
            }
              if (req.poconfirmStartDate) {
                query += ` AND purchase_order_date between '${req.poconfirmStartDate}'  and '${req.poconfirmEndDate}'`;
            }
              if (req.confirmStartDate) {
                query += ` AND po.expected_delivery_date between '${req.confirmStartDate}' and '${req.confirmEndDate}'`;
            }
            if(req.tab){
                query += ` AND po_material_type LIKE '%${req.tab}%'`
            }
            //   if (req.status){
                
            //     // query += `and po.status IN  ('${req.status})')`
            //     query += ` AND po.status IN ("${req.status}")`
            //   }
            }
            
             query+= ` GROUP BY po.purchase_order_id ORDER BY po.expected_delivery_date`
            const data = await this.dataSource.query(query,param)
            console.log(data);
            if (data.length > 0) {
                return new CommonResponseModel(true, 0, "PO Numbers retrieved successfully", data)
            } else {
                return new CommonResponseModel(false, 1, "No data found", [])
            }
        } catch (err) {
            throw (err)
        }
    }

    async GetPurchaseFabricData(purchaseOrderId: number): Promise<CommonResponseModel> {
        try {
            // console.log(purchaseOrderId)
            let query = `SELECT u.uom AS quantityUom,item_code AS itemCode,c.colour AS colourName,po_fabric_id AS pofabricId,pf.colour_id AS colourId,
            m3_fabric_code AS m3fabricCode,shahi_fabric_code AS shahiFabricCode,purchase_order_id AS purchaseOrderId,
            indent_fabric_id AS indentFabricId,po_quantity AS poQuantity,
            quantity_uom_id AS quantityUomId,
            fab_item_status AS fabItemStatus,grn_quantity
            FROM purchase_order_fabric pf
            LEFT JOIN colour c ON c.colour_id=pf.colour_id
            LEFT JOIN m3_items mi ON mi.m3_items_Id=pf.m3_fabric_code
            LEFT JOIN uom u ON u.id=quantity_uom_id where pf.purchase_order_id=`+ purchaseOrderId + ``
            const data = await this.dataSource.query(query)
            if (data.length > 0) {
                return new CommonResponseModel(true, 0, "PO Numbers retrieved successfully", data)
            } else {
                return new CommonResponseModel(false, 1, "No data found", [])
            }
        } catch (err) {
            throw (err)
        }
    }
    async GetPurchaseTrimData(purchaseOrderId: number): Promise<CommonResponseModel> {
        try {
            let query = `SELECT ri.trim_code AS trimcode,ri.trim_type AS trimtype,pg.product_group AS productGroup,po_trim_id AS poTrimid,pt.product_group_id AS productGrouoId,trim_id AS trimId,m3_trim_code AS m3trimCode ,
            purchase_order_id,colour_id AS clourId,
                       indent_trim_id AS indentTrimId,po_quantity AS poQuantity,trim_item_status AS trimItemStaus ,
                       grn_quantity AS grnQuantity 
                       FROM purchase_order_trim pt
                       LEFT JOIN product_group pg ON pg.product_group_id=pt.product_group_id
                       LEFT JOIN m3_trims ri ON ri.m3_trim_Id =pt.m3_trim_code
                        where pt.purchase_order_id=`+ purchaseOrderId + ``
            const data = await this.dataSource.query(query)
            if (data.length > 0) {
                return new CommonResponseModel(true, 0, "PO Numbers retrieved successfully", data)
            } else {
                return new CommonResponseModel(false, 1, "No data found", [])
            }
        } catch (err) {
            throw (err)
        }
    }
    async getAllPurchaseOrderData(req?: PurchaseViewDto): Promise<CommonResponseModel> {

        try {
            const data = []
            const podata = await this.GetPurchaseData(req)
            // console.log(podata);
            for (const po of podata.data) {
                // const fabData = await this.GetPurchaseFabricData(po.purchaseOrderId)
                // const fabricInfo = []
                // for (const fabrData of fabData.data) {
                // //     console.log(fabrData)
                // //     console.log('**************************8')
                //     fabricInfo.push(fabrData)
                // }
                // const trimData = await this.GetPurchaseTrimData(po.purchaseOrderId)
                // const triminfo = []
                // for (const trim of trimData.data) {
                //     triminfo.push(trim)
                // }
            // console.log(po);

                data.push({
                    styleName: po.styleName,
                    purchaseOrderId: po.purchaseOrderId,
                    poNumber: po.poNumber,
                    buyerId: po.buyerId,
                    buyername: po.buyername,
                    vendorId: po.vendorId,
                    vendorName: po.vendorName,
                    expectedDeliverydate: po.expectedDeliverydate,
                    purchaseOrderDate: po.purchaseOrderDate,
                    poMaterialtype: po.poMaterialtype,
                    poStatus: po.poStatus,
                    poId:po.purchaseOrderId,
                    poAgainst: po.poAgainst,
                    orderType:po.orderType,
                    code:po.code,
                    address:po.address,
                    plantId:po.plantId,
                    plantName:po.plantName,
                    pIDate:po.pIDate,
                    indentNo:po.indentNo,
                    isFreezed:po.isFreezed

                    // fabInfo: fabricInfo,
                    // triminfo: triminfo

                })
            }
            if (data) {

                return new CommonResponseModel(true, 1, 'data retrived sucessfully', data)

            } else {
                return new CommonResponseModel(false, 0, 'no data found', [])

            }

        }
        catch (err) {
            throw err
        }
    }

    async getPodetailsById(req:PurchaseViewDto):Promise<CommonResponseModel>{
        const PoType = `select po_material_type,po_against from purchase_order where purchase_order_id = ${req.id}`
        const poTypeRes = await this.dataSource.query(PoType)
        // console.log(poTypeRes,'poTypeResdd')
        let concatString
        let columnName
        let joinString
        let columns
        // console.log(poTypeRes[0].po_against,'kkkkkk')
        if(poTypeRes[0].po_against == 'Sample Order' && poTypeRes[0].po_material_type == 'Fabric'){
            joinString = `LEFT JOIN sample_request_fabric_info srf ON srf.fabric_info_id = poi.sample_item_id
            LEFT JOIN sample_request s ON s.sample_request_id = srf.sample_request_id
            LEFT JOIN buyers fb on fb.buyer_id = s.buyer_id`
            columns = `,fb.buyer_name AS iBuyerName,s.request_no as sample_req_no,s.expected_delivery_date as date ` 
        }else if(poTypeRes[0].po_against == 'Sample Order' && poTypeRes[0].po_material_type == 'Trim'){
            joinString = `LEFT JOIN sample_request_trim_info srt ON srt.trim_info_id = poi.sample_item_id
            LEFT JOIN sample_request sr ON sr.sample_request_id = srt.sample_request_id LEFT JOIN buyers tb on tb.buyer_id = sr.buyer_id`
            columns = `,tb.buyer_name AS iBuyerName,i.request_no,i.indent_date, sr.request_no as sample_req_no`
        }
        // let poData = `select * from purchase_order po `
        if(poTypeRes[0].po_material_type == 'Fabric'){
            concatString = ` 
            left join m3_items mi on mi.m3_items_Id = poi.m3_item_id left join uom u ON u.id = poi.quantity_uom_id 
            LEFT JOIN indent_fabric ii ON ii.ifabric_id = poi.indent_item_id ${joinString != undefined ? joinString:""}
            `
            columnName =    `mi.order_type as orderType,mi.min_moq_quantity as monMoqQuantity,mi.max_moq_quantity as maxMoqQuantity,mi.tolerance,mi.item_code,mi.hsn_code as hsnCode,mi.description,u.uom ${columns != undefined ? columns:""}`
        //     poData = poData+` left join purchase_order_fabric pof on pof.purchase_order_id = po.purchase_order_id `
        }else{
            concatString = ` 
            left join m3_trims mi on mi.m3_trim_Id = poi.m3_item_id left join uom u ON u.id = poi.quantity_uom_id
            LEFT JOIN indent_trims ii ON ii.itrims_id = poi.indent_item_id ${joinString != undefined ? joinString:""}
            
            `
            columnName = `mi.trim_code as item_code , mi.hsn_code as hsnCode,mi.description ,u.uom ${columns != undefined ? columns:""} `
        //     poData = poData+` left join purchase_order_trim pot on pot.purchase_order_id = po.purchase_order_id`
        }
        // poData = poData+` where po.purchase_order_id = ${req.id}`
        // const podatares = await this.dataSource.query(poData)
        
        const poTrimData = `select v.vendor_code AS vendorCode,b.buyer_name AS buyerName, po.*,poi.*,${columnName},poi.unit_price,i.request_no as indentNo,i.indent_date as indentDate,v.vendor_name,v.contact_number,v.bank_acc_no,v.gst_number,v.postal_code,concat(f.name,'-',f.address) AS address,t.tax_percentage AS taxPercentage ,cur.currency_name as currencyName,co.colour,si.sizes AS size,poi.hsn_code AS poHsnCode, pm.payment_method AS paymentMethod,pt.payment_terms_name AS paymentTerms, dm.delivery_method AS deliveryMethod, dt.delivery_terms_name AS deliveryTerms, pact.packing_terms AS packingTerms, ft.freight_terms AS freightTerms,poi.in_house_date as inHouseDate,poi.shade_no as poIteShadeNo,poi.converted_quantity as convertedQuantity,po.your_ref_no AS yourRefNo,po.ref_no as refNo,i.request_no as indentcode,po.exchange_rate as exchangeRate,po.po_against as poAgainst,po.purchase_order_date as poDate,po.pIDate,po.is_freezed AS isFreezed from purchase_order po
        left join purchae_order_items poi on poi.purchase_order_id = po.purchase_order_id ${concatString}
        LEFT JOIN indent i ON i.indent_id = ii.indent_id 
        left join factory f on f.id = po.delivery_address 
        LEFT JOIN buyers b ON b.buyer_id = i.buyer_id 
        left join currencies cur on cur.currency_id=po.currency_id  
        LEFT JOIN colour co ON co.colour_id = poi.colour_id
        LEFT JOIN size si ON si.size_id = poi.size_id
        left join vendors v on v.vendor_id = po.vendor_id LEFT JOIN taxes t ON t.tax_id = poi.tax
        LEFT JOIN payment_method pm ON pm.payment_method_id = po.payment_methods
        LEFT JOIN payment_terms pt ON pt.payment_terms_id = po.payment_terms
        LEFT JOIN delivery_method dm ON dm.delivery_method_id = po.delivery_methods
        LEFT JOIN delivery_terms dt ON dt.delivery_terms_id = po.delivery_terms
        LEFT JOIN freight_terms ft ON ft.freight_terms_id = po.freight_terms
        LEFT JOIN packing_terms pact ON pact.packing_terms_id = po.packing_terms
       
        where po.purchase_order_id = ${req.id} `
        // console.log(poTrimData,'ppppppphhh')
        // console.log(concatString,'columnsssss');

        const poTrimdatares = await this.dataSource.query(poTrimData)
        // console.log(podatares)
        // const PoDetails = {
        //     fabricInfo:[],
        //     trimInfo:[]
        // }
        if(poTrimdatares.length > 0){
            // PoDetails.fabricInfo = podatares
            // PoDetails.trimInfo = poTrimdatares
            return new CommonResponseModel(true,1,'data retreived',poTrimdatares)
        }else{
            return new CommonResponseModel(false,0,'No data')
        }
        return 
    }
    async getAllPos(): Promise<CommonResponseModel> {
        try {
            let query = `SELECT p.purchase_order_id,p.po_number FROM  grn g LEFT JOIN purchase_order p ON p.purchase_order_id = g.po_id GROUP BY g.po_id order by g.item_type, g.po_id ASC`
            const data = await this.dataSource.query(query)
            if (data.length > 0) {
                return new CommonResponseModel(true, 0, "PO Numbers retrieved successfully", data)
            } else {
                return new CommonResponseModel(false, 1, "No data found", [])
            }
        } catch (err) {
            throw (err)
        }
    }
    async QrByPoId(req: VendorIdReq): Promise<CommonResponseModel> {
        try {
            let query = `SELECT grn.grn_id,p.purchase_order_id, gi.grn_item_id,gi.grn_item_no,grn.invoice_no,grn.item_type, IF(grn.item_type = "FABRIC",mit. item_code , 
            mtr.trim_code) AS itemCode,tpm.structure, tpm.category, tpm.content, tpm.type, tpm.finish, tpm.hole, tpm.quality, tpm.thickness, tpm.variety, tpm.uom, tpm.color, tpm.logo, tpm.part FROM  purchase_order p 
            LEFT JOIN grn ON grn.po_id = p.purchase_order_id
            LEFT JOIN grn_items gi ON gi.grn_id = grn.grn_id
            LEFT JOIN m3_items mit ON mit.m3_items_id = gi.m3_item_code_id AND grn.item_type = "FABRIC"
            LEFT JOIN m3_trims mtr ON mtr.m3_trim_Id = gi.m3_item_code_id AND grn.item_type != "FABRIC"
            LEFT JOIN trim_params_mapping tpm ON tpm.trim_mapping_id = mtr.trim_mapping_id
            WHERE p.purchase_order_id = '${req.poId}'`
            const data = await this.dataSource.query(query)
            if (data.length > 0) {
                const modifiedRes = data.map(item => {
                    const trueValues = Object.keys(item)
                    .filter(key => ["structure", "category", "content", "type", "finish", "hole", "quality", "thickness", "variety", "uom", "color", "logo", "part"].includes(key) && item[key] === 1)
                    .map(key => key.toUpperCase());
    
                    const concatenatedValues = trueValues.join('/');
                    const label = trueValues.length > 0 ? "BUYER/TRIM TYPE/TRIM CATEGORY/":""

                    const trimParams = label + concatenatedValues
                    return { ...item, trimParams };
                })
            // if (data.length > 0) {
                 return new CommonResponseModel(true, 0, "PO Numbers retrieved successfully", modifiedRes)
            } else {
                return new CommonResponseModel(false, 1, "No data found", [])
            }
        } catch (err) {
            throw (err)
        }
    }
 async getUnit ():Promise<CommonResponseModel>{
    let unit =` SELECT pl.plant_Name as plantName FROM purchase_order p
     LEFT JOIN buyers b ON p.buyer_id = b.buyer_id
        LEFT JOIN purchae_order_items poi ON poi.purchase_order_id = p.purchase_order_id 
        LEFT JOIN sample_request_fabric_info srf ON srf.fabric_info_id = poi.sample_item_id
        LEFT JOIN sample_request s ON s.sample_request_id = srf.sample_request_id
        LEFT JOIN factory f ON f.id = p.delivery_address 
        LEFT JOIN currencies cur ON cur.currency_id=p.currency_id  
        LEFT JOIN vendors v ON v.vendor_id = p.vendor_id 
        LEFT JOIN taxes t ON t.tax_id = poi.tax
        LEFT JOIN m3_trims mt ON mt.m3_trim_Id = poi.m3_item_id  AND  p.po_material_type !='FABRIC'
        LEFT JOIN uom u ON u.id = poi.quantity_uom_id
        LEFT JOIN indent_trims ii ON ii.itrims_id = poi.indent_item_id 
        LEFT JOIN indent i ON i.indent_id = ii.indent_id 
        LEFT JOIN plants pl ON pl.plant_id = i.plant_id
        LEFT JOIN m3_items mi ON mi.m3_items_Id = poi.m3_item_id  AND  p.po_material_type ='FABRIC'
          WHERE pl.plant_Name IS NOT NULL
        GROUP BY pl.plant_Name`
         const Res = await this.dataSource.query(unit)

         if(Res.length > 0){
            // PoDetails.fabricInfo = podatares
            // PoDetails.trimInfo = poTrimdatares
            return new CommonResponseModel(true,1,'data retreived',Res)
        }else{
            return new CommonResponseModel(false,0,'No data')
        }
 }
    async getPodetails(req?:PoReq):Promise<CommonResponseModel>{
        let PoType = `SELECT p.po_number,p.expected_delivery_date,p.purchase_order_date,p.po_against,poi.item_type,p.status,p.total_amount,
        poi.po_item_status,v.vendor_name,cur.currency_name,f.name AS factory,t.tax_name,u.uom,poi.po_quantity,poi.grn_quantity,pl.plant_Name as plantName,
        IF(p.po_against = 'Sample Order',s.expected_delivery_date,i.indent_date) AS DATE,
        IF(p.po_against = 'Sample Order',s.request_no,i.request_no) AS request_no,
        IF(p.po_material_type ='FABRIC',mi.item_code,mt.description) AS item_code
        FROM purchase_order p
        LEFT JOIN buyers b ON p.buyer_id = b.buyer_id
        LEFT JOIN purchae_order_items poi ON poi.purchase_order_id = p.purchase_order_id 
        LEFT JOIN sample_request_fabric_info srf ON srf.fabric_info_id = poi.sample_item_id
        LEFT JOIN sample_request s ON s.sample_request_id = srf.sample_request_id
        LEFT JOIN factory f ON f.id = p.delivery_address 
        LEFT JOIN currencies cur ON cur.currency_id=p.currency_id  
        LEFT JOIN vendors v ON v.vendor_id = p.vendor_id 
        LEFT JOIN taxes t ON t.tax_id = poi.tax
        LEFT JOIN m3_trims mt ON mt.m3_trim_Id = poi.m3_item_id  AND  p.po_material_type !='FABRIC'
        LEFT JOIN uom u ON u.id = poi.quantity_uom_id
        LEFT JOIN indent_trims ii ON ii.itrims_id = poi.indent_item_id 
        LEFT JOIN indent i ON i.indent_id = ii.indent_id 
        LEFT JOIN plants pl ON pl.plant_id = i.plant_id
        LEFT JOIN m3_items mi ON mi.m3_items_Id = poi.m3_item_id  AND  p.po_material_type ='FABRIC'
         where 1 =1`

        if(req.extRefNo!=null && req.extRefNo != 'admin'){
            PoType += ` AND b.external_ref_number ='${req.extRefNo}'`
        }
        if (req.PoFromDate) {
            PoType += ` AND DATE(p.purchase_order_date) between '${req.PoFromDate}'  and '${req.PoToDate}'`;
        }
          if (req.ETDfromDate) {
            PoType += ` AND DATE(p.expected_delivery_date) between '${req.ETDfromDate}' and '${req.ETDtoDate}'`;
        }
        if(req.poId){
            PoType += ` AND p.purchase_order_id ='${req.poId}'`
        }
        if(req.poAgainst){
            PoType += ` AND p.po_against ='${req.poAgainst}'`
        }
        if(req.tab!= undefined){
            PoType += ` AND p.po_material_type LIKE '%${req.tab}%'`
        }
        if(req.plantName != undefined){
            PoType +=` AND pl.plant_Name ='${req.plantName}'`
        }
        const Res = await this.dataSource.query(PoType)
       
        if(Res.length > 0){
            // PoDetails.fabricInfo = podatares
            // PoDetails.trimInfo = poTrimdatares
            return new CommonResponseModel(true,1,'data retreived',Res)
        }else{
            return new CommonResponseModel(false,0,'No data')
        }
        return 
    }
    async getPoNum():Promise<CommonResponseModel>{
        let PoType = `SELECT p.po_number,p.purchase_order_id FROM purchase_order p `
        const Res = await this.dataSource.query(PoType)
       
        if(Res.length > 0){
            // PoDetails.fabricInfo = podatares
            // PoDetails.trimInfo = poTrimdatares
            return new CommonResponseModel(true,1,'data retreived',Res)
        }else{
            return new CommonResponseModel(false,0,'No data')
        }
        return 
    }

    async getQrCodeData(req?:xlNoReq):Promise<CommonResponseModel>{
        try {
            let type = req.type;
            let quaery = " and s.item_type = '"+type+"'";
            if(type === "trim"){
                quaery = " and s.item_type != 'FABRIC'";
            }
            let PoType = `SELECT bi.buyer_name AS buyer, s.count,rp.rack_position_name AS location,s.width,s.quantity,s.gsm,ct.content,IF(v.vendor_name IS null, pv.vendor_name, v.vendor_name) AS vendor,m3.description,c.colour,b.brand_name AS brand,IF(s.fabric_po IS null,po.po_number,s.fabric_po) AS fabricPo, s.excel_no AS xlNo,st.fob,g.grn_number as grnNumber,g.grn_id as grnId,gi.accepted_quantity as grnQuantity FROM stocks s left join buyers bi on bi.buyer_id = s.buyer_id 
            left join style st on st.style_id = s.style_id 
            left join colour c on c.colour_id = s.colour_id 
            left join brands b on b.brand_id = st.brand_id 
            left join m3_items m3 on m3.m3_items_Id = s.m3_item 
            left join vendors v on v.vendor_id = s.vendor_id 
            left join content ct on ct.content_id = s.content_id 
            left join rack_position rp on rp.position_Id = s.location_id 
            left join grn_items gi on gi.grn_item_id = s.grn_item_id
            left join purchase_order po on po.purchase_order_id = gi.po_id 
            left join vendors pv on pv.vendor_id = po.vendor_id 
            left join grn g on g.grn_id=gi.grn_id
            where s.id = `+req.stockId+` and s.excel_no = '`+req.xlNo+`'`+ quaery+` limit 1`;
            const res = await this.dataSource.query(PoType)
            if(res.length > 0){
                return new CommonResponseModel(true,1,'data retreived',res)
            }
            else{
                return new CommonResponseModel(false,0,'no data found',)
            }
        }catch (err) {
            throw (err)
        }
    }

    async getTrimQrCodeData(req?:xlNoReq):Promise<CommonResponseModel>{
        try {
            let type = req.type;
            let quaery = " and s.item_type = '"+type+"'";
            if(type === "trim"){
                quaery = " and s.item_type != 'FABRIC'";
            }
            let PoType = `SELECT ar.text,u.uom,m3.perforation,fi.finish,ah.air_hole as airHole, ar.article_name AS article,fs.function,g.gauge,h.hole,id.inner_dia AS innerDia,l.length,ln.line,lo.logo,p.parts,py.ply,q.quality,sp.shape,str.structure,th.thickness,tb.trim_buyer AS buyer,ts.trim_size as size,typ.type,vr.variety,ctg.category,tri.trim_category AS trimCategory,s.count,rp.rack_position_name AS location,s.width,s.quantity,s.gsm,ct.content,v.vendor_name AS vendor,m3.description,c.colour,b.brand_name AS brand,s.fabric_po AS fabricPo, s.xl_no AS xlNo,'N/A' AS fob FROM stocks s 
            left join style st on st.style_id = s.style_id 
            left join colour c on c.colour_id = s.colour_id 
            left join brands b on b.brand_id = st.brand_id 
            left join m3_trims m3 on m3.m3_trim_Id = s.m3_item 
            left join trim tri on tri.trim_id = m3.trim_category_id 
            left join category ctg on ctg.category_id = m3.category_id 
            left join finish fi on fi.finish_id = m3.finish_id 
            left join air_holes ah on ah.air_hole_id = m3.air_hole_id 
            left join article ar on ar.article_id = m3.article_id 
            left join trim_functions fs on fs.function_id = m3.function_id 
            left join gauge g on g.gauge_id = m3.gauge_id 
            left join hole h on h.hole_id = m3.hole_id 
            left join inner_dia id on id.inner_dia_id = m3.inner_dia_id 
            left join length l on l.length_id = m3.length_id 
            left join line ln on ln.line_id = m3.line_id 
            left join logo lo on lo.logo_id = m3.logo 
            left join parts p on p.parts_id = m3.parts_id 
            left join ply py on py.ply_id = m3.ply_id 
            left join quality q on q.quality_Id = m3.quality_Id 
            left join shape sp on sp.shape_id = m3.shape_id 
            left join structure str on str.structure_id = m3.structure_id 
            left join thickness th on th.thickness_id = m3.thickness_id 
            left join trim_buyer tb on tb.trim_buyer_id = m3.trim_buyer_id 
            left join trim_size ts on ts.trim_size_id = m3.trim_size_id 
            left join type typ on typ.type_id = m3.type_id 
            left join variety vr on vr.variety_id = m3.variety_id 
            left join vendors v on v.vendor_id = s.vendor_id 
            left join content ct on ct.content_id = s.content_id 
            left join uom u on u.id = m3.uom_id 
            left join rack_position rp on rp.position_Id = s.location_id 
            where s.id = `+req.stockId + ` `;
            if(req.xlNo != null){
                PoType = PoType+` and s.xl_no = '`+req.xlNo+`' `;
            }
            PoType = PoType + quaery+` limit 1`;
            const res = await this.dataSource.query(PoType)
            if(res.length > 0){
                return new CommonResponseModel(true,1,'data retreived',res)
            }
            else{
                return new CommonResponseModel(false,0,'no data found',)
            }
        }catch (err) {
            throw (err)
        }
    }

    async getPoNumByMaterialType(req:MaterialTypeDto):Promise<CommonResponseModel>{
        let PoType = await this.poRepo.find({select:["purchaseOrderId","poNumber"],where:{poMaterialType:req.materialType}, order:{poNumber:'ASC'}})
        console.log(PoType)
        if(PoType.length > 0){
            let result: any[] = [];
            let data: any[] = [];
            for(const res of PoType){
                console.log(res);
                let checkGrn = await this.grnRepo.findOne({where:{poId:res.purchaseOrderId}});
                console.log(checkGrn)
                if(checkGrn != null){
                    result.push(res);
                }
                else{
                    data.push(res);
                }
            }
            console.log(result);
            console.log(data);

            return new CommonResponseModel(true,1,'data retreived',req.advancePayment === PerforationEnum.NO ? result : data)
        }else{
            return new CommonResponseModel(false,0,'No data')
        }
        return 
    }


    async updateFreezingStatus(req:purchaseOrdeIdreq):Promise<CommonResponseModel>{
        try{
            let PoType = await this.poRepo.update({purchaseOrderId:req.purchaseOrderId},{isFreezed:req.isFreezed});
            if(PoType.affected > 0){
                return new CommonResponseModel(true,1,'Status Updated successfully. ',)
            }else{
                return new CommonResponseModel(false,0,'No data')
            }
        }catch (err) {
            throw (err)
        }
    }

    async freezePoAfter14days():Promise<CommonResponseModel>{
        try{

            let query = "update purchase_order set is_freezed = true where DATEDIFF(NOW(), created_at) >14"
            const res = await this.dataSource.query(query)

            if(res.affected > 0){
                return new CommonResponseModel(true,1,'Status Updated successfully. ',)
            }else{
                return new CommonResponseModel(false,0,'No data')
            }
        }catch (err) {
            throw (err)
        }
    }

  
}

